var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var Search = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 24 24" }),
        React.createElement("path", { d: "M23.82,23.11l-7.37-7.37a9.49,9.49,0,1,0-.74.74l7.37,7.37a.52.52,0,0,0,.74-.74ZM9.42,17.86a8.41,8.41,0,1,1,8.41-8.41A8.42,8.42,0,0,1,9.42,17.86Z" })));
};
export default Search;
